import React from 'react';
import './header.css';
const Header = () => {
    return (
        <div className="header">
            <h1>*** Hire Web Developer ***</h1>
            <h3>We Have 20 + Developers</h3>
            <h5>Total Budget: {100} Million</h5>
        </div>
    );
};

export default Header;